<div class="row fw-bold small mb-5 mt-5 mt-xl-0">
  <div class="single-step col pe-0 lh-1" [ngClass]="{'step-active' : step === 1, 'step-done' : step > 1}">
    <div class="single-step-inner position-relative">

      <!-- Mobile -->
      <div class="block mb-1 d-xl-none pe-4 pe-md-5">
        <div *ngIf="step === 1" class="single-step-mobile bg-primary p-1 rounded"></div>
        <div *ngIf="step > 1" class="bg-success p-1 rounded"></div>
      </div>
      <div class="step-name pt-1 d-xl-none" [ngClass]="{'text-primary' : step === 1, 'text-success' : step > 1}">{{'General.StepLeadGeneration' | translate}}</div>

      <!-- Desktop -->
      <div class="circle mb-3 d-none d-xl-block">
        <div *ngIf="step === 1"
             class="circle-outer position-relative bg-primary border-primary border border-2 rounded-circle">
          <div class="circle-inner bg-primary border-white border border-2 rounded-circle"></div>
        </div>
        <div *ngIf="step > 1" class="circle-outer position-relative bg-primary text-white rounded-circle text-center">
          <i class="fa-solid fa-check"></i>
        </div>
      </div>

      <div class="text-body-secondary text-uppercase d-none d-xl-block">{{ 'General.Step' | translate }} 1</div>
      <div class="step-name pt-1 text-primary d-none d-xl-block">{{'General.StepLeadGeneration' | translate}}</div>
    </div>
  </div>

  <ng-container *ngIf="step2Active">
    <div class="single-step col p-0 lh-1"
         [ngClass]="{'step-active' : step === 2, 'step-done' : step > 2}">
      <div class="single-step-inner position-relative">

        <!-- Mobile -->
        <div class="block mb-1 d-xl-none pe-4 pe-md-5">
          <div *ngIf="step === 2" class="single-step-mobile bg-primary p-1 rounded"></div>
          <div *ngIf="step < 2" class="bg-secondary p-1 rounded"></div>
          <div *ngIf="step > 2" class="bg-success p-1 rounded"></div>
        </div>
        <div class="step-name pt-1 d-xl-none" [ngClass]="{'text-primary' : step === 2, 'text-success' : step > 2, 'text-secondary' : step < 2}">{{ 'General.StepValuesInDispute' | translate}}</div>

        <!-- Desktop -->
        <div class="circle mb-3 d-none d-xl-block ">
          <div *ngIf="step === 2"
               class="circle-outer position-relative bg-primary border-primary border border-2 rounded-circle">
            <div class="circle-inner bg-primary border-white border border-2 rounded-circle"></div>
          </div>
          <div *ngIf="step < 2" class="circle-outer position-relative bg-body-secondary rounded-circle">
          </div>
          <div *ngIf="step > 2" class="circle-outer position-relative bg-primary text-white rounded-circle text-center">
            <i class="fa-solid fa-check"></i>
          </div>
        </div>

        <div class="text-body-secondary text-uppercase d-none d-xl-block">{{ 'General.Step' | translate }} 2</div>
        <div class="step-name d-none d-xl-block pt-1" [ngClass]="{'text-primary' : step > 1, 'text-secondary' : step < 2}">{{ 'General.StepValuesInDispute' | translate}}</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="step3Active">
    <div class="single-step col p-0 lh-1"
         [ngClass]="{'step-active' : step === 3, 'step-done' : step > 3}">
      <div class="single-step-inner position-relative">

        <!-- Mobile -->
        <div class="block mb-1 d-xl-none pe-4 pe-md-5">
          <div *ngIf="step === 3" class="single-step-mobile bg-primary p-1 rounded"></div>
          <div *ngIf="step < 3" class="bg-secondary p-1 rounded"></div>
          <div *ngIf="step > 3" class="bg-success p-1 rounded"></div>
        </div>
        <div class="step-name pt-1 d-xl-none" [ngClass]="{'text-primary' : step === 3, 'text-success' : step > 3, 'text-secondary' : step < 3}">{{ 'General.StepContract' | translate}}</div>

        <!-- Desktop -->
        <div class="circle mb-3 d-none d-xl-block">
          <div *ngIf="step === 3"
               class="circle-outer position-relative bg-primary border-primary border border-2 rounded-circle">
            <div class="circle-inner bg-primary border-white border border-2 rounded-circle"></div>
          </div>
          <div *ngIf="step < 3" class="circle-outer position-relative bg-body-secondary rounded-circle">
          </div>
          <div *ngIf="step > 3" class="circle-outer position-relative bg-primary text-white rounded-circle text-center">
            <i class="fa-solid fa-check"></i>
          </div>
        </div>

        <div class="text-body-secondary text-uppercase d-none d-xl-block">{{ 'General.Step' | translate }} 3</div>
        <div class="step-name d-none d-xl-block pt-1" [ngClass]="{'text-primary' : step > 2, 'text-secondary' : step < 3}">{{ 'General.StepContract' | translate}}</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="step4Active && step4Available">
    <div class="single-step col p-0 lh-1"
         [ngClass]="{'step-active' : step === 4, 'step-done' : step > 4}">
      <div class="single-step-inner position-relative">

        <!-- Mobile -->
        <div class="block mb-1 d-xl-none pe-4 pe-md-5">
          <div *ngIf="step === 4" class="single-step-mobile bg-primary p-1 rounded"></div>
          <div *ngIf="step < 4" class="bg-secondary p-1 rounded"></div>
          <div *ngIf="step > 4" class="bg-success p-1 rounded"></div>
        </div>
        <div class="step-name pt-1 d-xl-none" [ngClass]="{'text-primary' : step === 4, 'text-success' : step > 4, 'text-secondary' : step < 4}">Streitwert</div>

        <!-- Desktop -->
        <div class="circle mb-3 d-none d-xl-block ">
          <div *ngIf="step === 4"
               class="circle-outer position-relative bg-primary border-primary border border-2 rounded-circle">
            <div class="circle-inner bg-primary border-white border border-2 rounded-circle"></div>
          </div>
          <div *ngIf="step < 4" class="circle-outer position-relative bg-body-secondary rounded-circle">
          </div>
          <div *ngIf="step > 4" class="circle-outer position-relative bg-primary text-white rounded-circle text-center">
            <i class="fa-solid fa-check"></i>
          </div>
        </div>
        <div class="text-body-secondary text-uppercase d-none d-xl-block">Schritt 4</div>
        <div class="step-name d-none d-xl-block pt-1" [ngClass]="{'text-primary' : step > 3, 'text-secondary' : step < 4}">Streitwert</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="datagGateActive">
    <div class="single-step col p-0 lh-1" [ngClass]="{'step-active' : step === 5}">
      <div class="single-step-inner position-relative">

        <!-- Mobile -->
        <div class="block mb-1 d-xl-none pe-4 pe-md-5">
          <div *ngIf="step === 5" class="single-step-mobile bg-primary p-1 rounded"></div>
          <div *ngIf="step < 5" class="bg-secondary p-1 rounded"></div>
          <div *ngIf="step > 5" class="bg-success p-1 rounded"></div>
        </div>

        <!-- Desktop -->
        <div class="circle mb-3 d-none d-xl-block ">
          <div *ngIf="step === 5"
               class="circle-outer position-relative bg-primary border-primary border border-2 rounded-circle">
            <div class="circle-inner bg-primary border-white border border-2 rounded-circle"></div>
          </div>
          <div *ngIf="step < 5" class="circle-outer position-relative bg-body-secondary rounded-circle">
          </div>
        </div>
        <div class="text-body-secondary text-uppercase d-none d-xl-block">Schritt 5</div>
        <div class="step-name pt-1" [ngClass]="{'text-primary' : step === 5, 'text-secondary' : step < 5}">#NAME STEP 5#</div>
      </div>
    </div>
  </ng-container>

</div>
